export const BLAZE_EVENTS = {
    RECORD_PAYMENT_LOAD_TIME: "checkout_payment_load_time",
    RECORD_CART_LOAD_TIME: "checkout_card_load_time",
    RECORD_TABLE_BOOKING_CART_LOAD_TIME: "dineout_checkout_load_time",
    RECORD_BILL_PAYMENT_CART_LOAD_TIME: "bill_payment_cart_load_time",
    RECORD_STEAL_STORE_CART_LOAD_TIME: "steal_store_cart_load_time",
    RECORD_APP_LOAD_TIME: "checkout_app_load_time",
    RECORD_DINEOUT_APP_LOAD_TIME: "dineout_checkout_app_load_time",
    RECORD_ORDER_LOAD_TIME: "checkout_order_load_time", // place order to confirm order
    RECORD_PROCESS_ORDER_LOAD_TIME: "checkout_process_order_load_time", // process order load time
    RECORD_CHECKOUT_PAYMENT_LOAD_TIME: "blaze_checkout_web_payment_load_time", // food checkout payment load time
    RECORD_DINEOUT_CHECKOUT_PAYMENT_LOAD_TIME: "blaze_dineout_checkout_web_payment_load_time", // dineout checkout payment load time
    RECORD_DO_PAYMENT_SUCCESS_SCREEN_LOAD_TIME: "blaze_do_payment_success_screen_load_time",
    RECORD_INTERMEDIATE_SHARED_CART_SCREEN_LOAD_TIME: "blaze_shared_cart_screen_load_time",
    RECORD_CHECKOUT_PAYMENT_MODES_LOAD_TIME: "blaze_checkout_web_payment_modes_load_time", // payment modes load time
};

export const ORIGINAL_BUSINESS_LINE = "original_business_line";
